module.exports = __webpack_public_path__ + "static/media/previous blac.9e5003fd.svg";